export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10044.a7bf74a2.jpg";